import { formatInteger } from '@/design'
import './list.css'

/** One choice in a list's chip group: pressed when chosen, with its count when it has one. */
export function Chip({
  pressed,
  onClick,
  disabled,
  title,
  count,
  children,
}: {
  pressed: boolean
  onClick: () => void
  disabled?: boolean
  /** Why it cannot be chosen, when it cannot. */
  title?: string
  count?: number
  children: string
}) {
  return (
    <button type="button" className="list-chip" aria-pressed={pressed} disabled={disabled} title={title} onClick={onClick}>
      {children}
      {count === undefined ? null : (
        <>
          {' '}
          <span className="list-chip__count">{formatInteger(count)}</span>
        </>
      )}
    </button>
  )
}
